import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';
import { MUIBreakpointLg } from '../../constants';

export const StyledMobileViewList = styled.div`
  background-color: ${token('colors.white')};
  border-top: 1px solid ${token('colors.gray300')};
  bottom: 0;
  left: -12px;
  right: -12px;
  position: absolute;
  top: 55px;
  z-index: 275;
  min-height: 700px;

  @media screen and (min-width: ${MUIBreakpointLg}) {
    display: none;
  }

  .MobileViewList-Link {
    border-bottom: 1px solid ${token('colors.gray300')};
    background-color: ${token('colors.white')};

    .Link {
      color: ${token('colors.textDark')};
      display: block;
      font-weight: normal;
      font-size: 16px;
      line-height: 1.5;
      padding: ${spaceMixin('sm')} ${spaceMixin('sm')} 20px;
      text-decoration: none;
    }

    .Link-signIn {
      padding: 16px 0 16px 20px;
      .Link {
        padding: 0;
        display: initial;
      }
    }
  }
`;

export const StyledSubText = styled.div`
  font-size: 12px;
  color: ${token('colors.textDark')};
  font-weight: normal;
`;
